import React from 'react';

import {
  ContentPageLayoutProps,
  FluentPageLayout,
} from '../../../../components/Layout/FluentPageLayout';

export const ModelProfilePageLayout: React.FC<
  Partial<ContentPageLayoutProps>
> = (props) => {
  return <FluentPageLayout {...props} />;
};
